import { render, staticRenderFns } from "./JpReceJPOfficeEditDialog.vue?vue&type=template&id=2c99c7b0&scoped=true"
import script from "./JpReceJPOfficeEditDialog.vue?vue&type=script&lang=js"
export * from "./JpReceJPOfficeEditDialog.vue?vue&type=script&lang=js"
import style0 from "./JpReceJPOfficeEditDialog.vue?vue&type=style&index=0&id=2c99c7b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c99c7b0",
  null
  
)

export default component.exports